import { Heading } from "@/components/study/Heading";
import { AppSurface } from "@shared/components/Surface";
import { CircleSlash } from "lucide-react";

export function ClosedView() {
  return (
    <div className="w-full max-w-2xl my-auto">
      <Heading />
      <AppSurface>
        <h2 className="text-lg font-medium flex items-center gap-x-1.5 mb-4 text-amber-500">
          <CircleSlash size={20} strokeWidth={3} />
          Study Closed
        </h2>
        <p className="text-gray-700 dark:text-neutral-300">
          This study is no longer accepting responses. Please reach out to your study coordinator if
          you have questions.
        </p>
      </AppSurface>
    </div>
  );
}
